import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { DocumentDraftFooterProps } from "models/propTypes/documentDraftPropTypes";
//#endregion
//#region components
import { PageFooter } from "components/common";
import DocumentDraftMoreActions from "./actions/moreActions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { useDispatch } from "react-redux";
import { documentDraftHandled } from "store/actions/documentDraftActions";

const DocumentDraftFooter: React.FC<DocumentDraftFooterProps> = (props) => {
  const dispatch = useDispatch();
  const onAcceptSuccess = () => {
    dispatch(documentDraftHandled(props.documentDraft.id));
    props.markAsDoneHandler && props.markAsDoneHandler();
  };
  return (
    <PageFooter
      actions={[
        {
          text: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Accept),
          onClick: props.onDocumentDraftAccept,
          type: StyleEnums.DisplayType.Success,
          onActionSuccess: onAcceptSuccess,
          successMessage: TranslationKeys.DocumentDraft.ApproveSuccessMessage,
        },
      ]}
      moreActions={
        <DocumentDraftMoreActions documentDraft={props.documentDraft} markAsDoneHandler={props.markAsDoneHandler} />
      }
      disableSuccessMessages={props.disableSuccessMessages}
    />
  );
};

export default DocumentDraftFooter;
